import { Select } from '@radix-ui/themes';
import { useGetEventFingerprintsQuery } from '../../../graphql/queries/GetEventFingerprints.generated';
import { EventFingerprint } from '@/types';

interface TopicFieldInputProps {
  onValueChange: (value: string) => void;
  disabled?: boolean;
}

const TopicFieldInput = ({ onValueChange, disabled }: TopicFieldInputProps) => {
  const { data, loading, error } = useGetEventFingerprintsQuery();

  if (loading) {
    return (
      <Select.Root disabled={true}>
        <Select.Trigger placeholder="Loading" />
      </Select.Root>
    );
  }

  if (error || !data) {
    return (
      <Select.Root disabled={true}>
        <Select.Trigger placeholder="Error loading event fingerprints" />
      </Select.Root>
    );
  }

  const eventFingerprints: EventFingerprint[] =
    data.eventFingerprints.edges.map((edge) => edge.node);

  return (
    <Select.Root disabled={disabled} onValueChange={onValueChange}>
      <Select.Trigger placeholder="Select an event fingerprint" />
      <Select.Content>
        {eventFingerprints.map((eventFingerprint) => (
          <Select.Item key={eventFingerprint.id} value={eventFingerprint.id}>
            {eventFingerprint.signatureText}
          </Select.Item>
        ))}
      </Select.Content>
    </Select.Root>
  );
};

export default TopicFieldInput;
